export function getFixedParametersResult(internalPeaks, normalizedY, x, globalInit, baseSumOfShapes, yScale) {
    const fittedValues = Array.from(globalInit);
    const newPeaks = [];
    for (const peak of internalPeaks) {
        const { id, shape, parameters, fromIndex } = peak;
        let newPeak = { x: 0, y: 0, shape };
        if (id) {
            //@ts-expect-error it is right step
            newPeak = { ...newPeak, id };
        }
        newPeak.x = fittedValues[fromIndex];
        newPeak.y = fittedValues[fromIndex + 1] * yScale;
        for (let i = 2; i < parameters.length; i++) {
            //@ts-expect-error it is right step
            newPeak.shape[parameters[i]] = fittedValues[fromIndex + i];
        }
        newPeaks.push(newPeak);
    }
    const fct = baseSumOfShapes(fittedValues);
    let error = 0;
    for (let i = 0; i < normalizedY.length; i++) {
        error += (normalizedY[i] - fct(x[i])) ** 2;
    }
    return {
        error,
        iterations: 0,
        peaks: newPeaks,
    };
}
//# sourceMappingURL=getFixedParametersResult.js.map